import { EmailMetadata } from '../../../models/EmailMetadata'
import { IntegrationEmail } from '../../../models/Email'
import { Form } from 'react-bootstrap'
import React from 'react'
import { updateEmailMetadata } from '../../../store/emailHub/emailMetadata'
import { useUpdateEmailMetadataMutation } from '../../../store/integrations/emailMetadata'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import { selectAccountId } from '../../../store/auth/authSlice'

export interface EmailProcessedProps {
  emailConnector: string
  email: IntegrationEmail
  metadata: EmailMetadata | null
}

export const EmailResponseProcessing: React.FC<EmailProcessedProps> = ({ emailConnector, email, metadata }) => {
  const dispatch = useAppDispatch()

  const accountId = useAppSelector(selectAccountId)
  const [triggerUpdateEmailMetadata, { isLoading: emailMetadataUpdateLoading }] = useUpdateEmailMetadataMutation()

  const handleProcess = async (processed: boolean) => {
    try {
      const emailMetadata = await triggerUpdateEmailMetadata({
        accountId,
        emailConnector,
        externalId: email.externalId,
        payload: {
          threadId: email.threadId,
          senderEmail: email.sender.email,
          processedByUser: processed,
        },
        removeEmptyValues: false,
      }).unwrap()
      dispatch(updateEmailMetadata(emailMetadata))
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <div className='d-flex p-3 mt-2 align-items-center justify-content-center zocks-border-0.5 zocks-bg-color-gray-100'>
      <div className='d-flex gap-2 align-items-center'>
        <Form.Check
          type='checkbox'
          className='d-flex align-items-center'
          checked={!!metadata?.processedByUser}
          onChange={async (e) => await handleProcess(e.target.checked)}
          disabled={emailMetadataUpdateLoading}
        />
        <div className='paragraph-medium'>Email reply is processed</div>
      </div>
    </div>
  )
}
